import { FORM_MODES } from 'modules/campaigns/config';
import { cleanCreativesEditingResources } from 'modules/campaigns/modules/creative-editor/flows';
import { generateLibraryCreativeEditorPath } from '../utils/generateLibraryCreativeEditorPath';

export const duplicateLibraryCreative = (data, navigate) => dispatch => {
    const { id: creativeId, accountName: accountId } = data;

    const duplicateLibraryCreativePath = generateLibraryCreativeEditorPath({
        mode: FORM_MODES.DUPLICATE,
        accountId,
        creativeId,
    });

    dispatch(cleanCreativesEditingResources());

    navigate(duplicateLibraryCreativePath);
};
